<template>
    <common-modal width="small" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="small">
            <common-content-spacer height="medium">
                <div class="modal-header">
                    <common-icon name="white-warning" size="medium-large"></common-icon>
                    <span class="modal-header--text">Please confirm time slot</span>
                </div>

                <user-details :user="selectedUser"></user-details>
                <p>{{ getConfrimSlotLabel }}</p>

                <common-buttons>
                    <common-button
                        :label="$t('common.microcopy.close')"
                        :isSubmittable="false"
                        :size="buttonSize"
                        type="secondary"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        :label="$t('common.microcopy.continue')"
                        :isSubmittable="false"
                        :size="buttonSize"
                        :isProcessing="loading"
                        type="primary"
                        @click="emitEvent({ name: 'continue' })"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    import UserDetails from 'components/page-elements/referrals/details/UserDetailsCard'
    import dayjs from 'dayjs'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        components: {
            UserDetails,
        },
        props: {
            selectedUser: { type: Object, required: true },
            selectedTimeslot: { type: Object, required: true },
            loading: { type: Boolean, default: false },
        },

        computed: {
            buttonSize() {
                return this.isTabletSmall ? 'small-font' : 'large'
            },

            getConfrimSlotLabel() {
                return `By clicking continue you will confirm ${this.formatDate(this.selectedTimeslot.date)} - ${
                    this.selectedTimeslot.startTime
                } - ${this.selectedTimeslot.endTime}!`
            },
        },

        methods: {
            formatDate(dateStr) {
                return dayjs(dateStr).format('DD MMM YYYY')
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .modal-header {
        display: flex;
        justify-content: center;
        align-items: center;

        .icon {
            margin-right: 10px;
        }

        &--text {
            line-height: $line-height--heading;
            font-size: 20px;
            font-weight: 700;
        }
    }
</style>
